/*
 * @Author: Alexander.Vangelov@vonage.com 
 * @Date: 2024-03-18 13:29:58 
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2024-03-27 10:56:17
 */

import { share } from '../share';

let guMask, guDialer, guDialerInput, guLegend, guLegendRight;

function closeDialer() {
  if (guMask && guDialerInput) {
    guDialerInput.value = '';
    document.body.removeChild(guMask);
  }
}

function updatePhoneInfo() {
  if (!guLegend || !guDialerInput) return;
  if (guDialerInput.value) {
    if (share.sendWorkerMessage) {
      share.sendWorkerMessage(
        { action: 'vPhoneNumberInfo', phoneNumber: guDialerInput.value }
      , (data) => {
        if (data) {
          guLegend.textContent = data.country;
          guLegendRight.textContent = data.numberType;
          guLegend.appendChild(guLegendRight);
        }
      });
    }
  } else {
    guLegend.textContent = '';
  }
}

function pageDialer(phoneNumber, callback) {
  if (guMask && guDialerInput) {
    guDialerInput.value = phoneNumber;
  } else {
    guMask = document.createElement('gu-mask');
    guMask.onclick = function (e) {
      if (e.target.nodeName === 'GU-BACKDROP') closeDialer();
    };
    guMask.onkeydown = function (e) {
      if (e.key == 'Escape' || e.key == 'Esc' || e.keyCode == 27) {
        closeDialer();
      }
    };

    const guBackdrop = document.createElement('gu-backdrop');
    guMask.appendChild(guBackdrop);

    guDialer = document.createElement('gu-dialer');

    const form = document.createElement('form');
    form.onsubmit = function (e) {
      e.preventDefault();
      e.stopPropagation();
      guDialerInput.focus();
      callback(guDialerInput.value);
      closeDialer();
      return false;
    };
    guDialerInput = document.createElement('input');
    guDialerInput.className = 'gu-input';
    guDialerInput.value = phoneNumber;
    guDialerInput.style.position = 'absolute';
    guDialerInput.style.height = '34px';
    guDialerInput.style.width = '188px';
    guDialerInput.style.borderTopLeftRadius = '3px';
    guDialerInput.style.borderBottomLeftRadius = '3px';
    guDialerInput.style.outline = 'none';
    guDialerInput.style.border = 0;
    guDialerInput.style.fontFamily = 'Arial, Helvetica, sans-serif';
    guDialerInput.style.fontSize = '20px';
    guDialerInput.style.fontWeight = '400';
    guDialerInput.style.padding = '1px 10px 0 30px';
    guDialerInput.style.margin = '0 0 0 5px';
    guDialerInput.style.backgroundImage = 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDE5Yy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnpNNiAxYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMCA2Yy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMCA2Yy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMTItOGMxLjEgMCAyLS45IDItMnMtLjktMi0yLTItMiAuOS0yIDIgLjkgMiAyIDJ6bS02IDhjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yem02IDBjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yem0wLTZjLTEuMSAwLTIgLjktMiAycy45IDIgMiAyIDItLjkgMi0yLS45LTItMi0yem0tNiAwYy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnptMC02Yy0xLjEgMC0yIC45LTIgMnMuOSAyIDIgMiAyLS45IDItMi0uOS0yLTItMnoiLz48L3N2Zz4=)';
    guDialerInput.style.backgroundRepeat = 'no-repeat';
    guDialerInput.style.backgroundPositionY = 'center';
    guDialerInput.style.textRendering = 'auto';
    guDialerInput.style.color = '#242526';
    guDialerInput.style.letterSpacing = 'normal';
    guDialerInput.style.wordSpacing = 'normal';
    guDialerInput.style.textTransform = 'none';
    guDialerInput.style.textIndent = '0px';
    guDialerInput.style.textShadow = 'none';
    guDialerInput.style.display = 'inline-block';
    guDialerInput.style.textAlign = 'start';
    guDialerInput.style.font = '20px Arial';
    guDialerInput.style.boxShadow = 'none';
    guDialerInput.style.backgroundColor = '#ffffff';
    guDialerInput.onkeyup = function (e) {
      updatePhoneInfo();
    };
    form.appendChild(guDialerInput);

    const button = document.createElement('button');
    button.type = 'submit';
    button.className = 'gu-button';
    button.style.backgroundImage = 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNNi42MiAxMC43OWMxLjQ0IDIuODMgMy43NiA1LjE0IDYuNTkgNi41OWwyLjItMi4yYy4yNy0uMjcuNjctLjM2IDEuMDItLjI0IDEuMTIuMzcgMi4zMy41NyAzLjU3LjU3LjU1IDAgMSAuNDUgMSAxVjIwYzAgLjU1LS40NSAxLTEgMS05LjM5IDAtMTctNy42MS0xNy0xNyAwLS41NS40NS0xIDEtMWgzLjVjLjU1IDAgMSAuNDUgMSAxIDAgMS4yNS4yIDIuNDUuNTcgMy41Ny4xMS4zNS4wMy43NC0uMjUgMS4wMmwtMi4yIDIuMnoiLz48L3N2Zz4=)';
    button.style.backgroundRepeat = 'no-repeat';
    button.style.backgroundPosition = 'center center';
    button.style.minWidth = 'initial';
    button.style.minHeight = 'initial';
    button.style.width = '36px';
    button.style.height = '33px';
    button.style.position = 'absolute';
    button.style.right = '-1px';
    button.style.margin = '1px';
    button.style.borderRadius = '0 3px 3px 0';
    button.style.outline = 'none';
    button.style.border = '0';
    button.style.backgroundColor = '#f5f5f5';
    button.style.cursor = 'pointer';
    button.style.lineHeight = '36px';
    button.style.verticalAlign = 'middle';
    button.style.alignItems = 'center';
    button.style.textAlign = 'center';
    form.appendChild(button);

    guDialer.appendChild(form);

    guLegend = document.createElement('gu-legend');
    guLegendRight = document.createElement('gu-legend-right');
    guLegend.appendChild(guLegendRight);
    guDialer.appendChild(guLegend);

    guMask.appendChild(guDialer);
  }
  if (share.c2sms || (window as any).VonageDialer?.c2sms) {
    const smsButton = document.createElement('button');
    smsButton.style.backgroundImage = 'url(data:image/svg+xml;base64,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)';
    smsButton.style.backgroundSize = '26px';
    smsButton.style.backgroundColor = 'transparent';
    smsButton.style.backgroundRepeat = 'no-repeat';
    smsButton.style.backgroundPosition = 'center center';
    smsButton.style.minWidth = 'initial';
    smsButton.style.minHeight = 'initial';
    smsButton.style.width = '36px';
    smsButton.style.height = '33px';
    smsButton.style.position = 'absolute';
    smsButton.style.border = 'none';
    smsButton.style.right = '38px';
    smsButton.style.top = '2px';
    smsButton.style.lineHeight = '36px';
    smsButton.style.verticalAlign = 'middle';
    smsButton.style.alignItems = 'center';
    smsButton.style.textAlign = 'center';
    smsButton.style.outline = 'none';
    smsButton.style.opacity = '1';
    smsButton.style.cursor = 'pointer';
    smsButton.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      guDialerInput.focus();
      callback(guDialerInput.value, true);
      closeDialer();
      return false;
    }
    guDialer.appendChild(smsButton);
  }
  guMask.style.zIndex = (share.scTopZIndex || 79) + 1;
  document.body.insertBefore(guMask, document.body.firstChild);
  guDialerInput.focus();
  updatePhoneInfo();
}

module.exports = function (dialMsg, dialCallback) {
  return pageDialer(dialMsg.data, function (dialNumber, c2sms) {
    dialMsg.data = dialNumber;
    if (c2sms) {
      dialMsg.action = 'guScSms'
    }
    dialCallback(dialMsg);
  });
};